import type { alat_berat, alat_berat_jenis, alat_berat_merk_model, biaya_alat_berat_random, biaya_alat_berat_sparepart, biaya_alat_berat_sparepart_bebas, buy_sparepart, copotan, login, pengiriman_sparepart, rent_alat_berat, rent_alat_berat_transactions, rent_alat_berat_transactions_progress, sell_alat_berat, sparepart, sparepart_jenis } from '@prisma/client'
import type { detailed_alat_berat_buy } from '~/server/api/buy-alat-berat/index.post'
import type { AlatBeratSubType } from '~~/server/api/AlatBeratSubType'
import type { ConvertToJsonType } from '~~/server/api/ConvertToJsonType'
import type { RemoveUnusedDbFields } from '~~/server/api/RemoveUnusedDbFields'
import type { SparepartSubType } from '~~/server/api/SparepartSubType'
import type { AlatBeratGetQuery } from '~/server/api/alat-berat/index.get'
import type { SparepartGetQuery } from '~/server/api/sparepart/index.get'
import type { BiayaAlatBeratSparepartGetQuery } from '~/server/api/biaya-alat-berat-sparepart/index.get'
import type { BuySparepartGetQuery } from '~/server/api/buy-sparepart/index.get'
import type { BiayaAlatBeratRandomGetQuery } from '~/server/api/biaya-alat-berat-random/index.get'
import type { BiayaAlatBeratSparepartBebasGetQuery } from '~/server/api/biaya-alat-berat-sparepart-bebas/index.get'
import type { ImageAlatBeratQuery } from '~/server/api/image-alat-berat/index.get'
import type { BuySparepartMulti } from '~/server/api/buy-sparepart-multi/index.post'
import type { RentAlatBeratGetQuery } from '~/server/api/rent-alat-berat/index.get'
import type { LogHistoryQuery } from '~/server/api/log-history/index.get'
import type { BiayaSparepartBebasMulti } from '~/server/api/biaya-alat-berat-sparepart-bebas-multi/index.post'
import type { detailed_copotan_image } from '~/server/api/copotan/index.post'
import type { ImageCopotanQuery } from '~/server/api/image-copotan/index.get'
import type { PengirimanSparepartGetQuery } from '~/server/api/pengiriman-sparepart/index.get'

// #region useDatabaseName
export const useDatabaseNameGet = () => useFetch('/api/database-name')

// #region useAlatBerat
export const useAlatBeratGet = (data?: {
  query?: AlatBeratGetQuery
}) => useFetch('/api/alat-berat/', JSON.parse(JSON.stringify(data || {})))
export const useAlatBeratGetId = (id: number) => useFetch(`/api/alat-berat/${id}`)
export const useAlatBeratPut = (id: number, body: RemoveUnusedDbFields<ConvertToJsonType<alat_berat>>) => useFetch(`/api/alat-berat/${id}`, {
  method: 'PUT',
  body
})
export const useAlatBeratPost = (body: RemoveUnusedDbFields<ConvertToJsonType<alat_berat>>) => useFetch('/api/alat-berat/', {
  method: 'POST',
  body
})
export const useAlatBeratDelete = (id: number) => useFetch(`/api/alat-berat/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useAlatBeratSub
export const useAlatBeratSubGet = (type: AlatBeratSubType) => useFetch(`/api/alat-berat/sub/${type}`)
export const useAlatBeratSubGetId = (type: AlatBeratSubType, id: number) => useFetch(`/api/alat-berat/sub/${type}/${id}`)
export const useAlatBeratSubPut = (type: AlatBeratSubType, id: number, body: RemoveUnusedDbFields<alat_berat_jenis>) => useFetch(`/api/alat-berat/sub/${type}/${id}`, {
  method: 'PUT',
  body
})
export const useAlatBeratSubPost = (type: AlatBeratSubType, body: RemoveUnusedDbFields<alat_berat_jenis>) => useFetch(`/api/alat-berat/sub/${type}`, {
  method: 'POST',
  body
})
export const useAlatBeratSubDelete = (type: AlatBeratSubType, id: number) => useFetch(`/api/alat-berat/sub/${type}/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useAlatBeratMerkModel
export const useAlatBeratMerkModelGet = () => useFetch('/api/alat-berat/model')
export const useAlatBeratMerkModelGetId = (id: number) => useFetch(`/api/alat-berat/model/${id}`)
export const useAlatBeratMerkModelPut = (id: number, body: RemoveUnusedDbFields<alat_berat_merk_model>) => useFetch(`/api/alat-berat/model/${id}`, {
  method: 'PUT',
  body
})
export const useAlatBeratMerkModelPost = (body: RemoveUnusedDbFields<alat_berat_merk_model>) => useFetch('/api/alat-berat/model', {
  method: 'POST',
  body
})
export const useAlatBeratMerkModelDelete = (id: number) => useFetch(`/api/alat-berat/model/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useSparepart
export const useSparepartGet = (data?: {
  query?: SparepartGetQuery
}) => useFetch('/api/sparepart', JSON.parse(JSON.stringify(data || {})))
export const useSparepartGetId = (id: number) => useFetch(`/api/sparepart/${id}`)
export const useSparepartPut = (id: number, body: RemoveUnusedDbFields<ConvertToJsonType<sparepart>>) => useFetch(`/api/sparepart/${id}`, {
  method: 'PUT',
  body
})
export const useSparepartPost = (body: RemoveUnusedDbFields<ConvertToJsonType<sparepart>>) => useFetch('/api/sparepart', {
  method: 'POST',
  body
})
export const useSparepartDelete = (id: number) => useFetch(`/api/sparepart/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useSparepartSub
export const useSparepartSubGet = (type: SparepartSubType) => useFetch(`/api/sparepart/sub/${type}`)
export const useSparepartSubGetId = (type: SparepartSubType, id: number) => useFetch(`/api/sparepart/sub/${type}/${id}`)
export const useSparepartSubPut = (type: SparepartSubType, id: number, body: RemoveUnusedDbFields<sparepart_jenis>) => useFetch(`/api/sparepart/sub/${type}/${id}`, {
  method: 'PUT',
  body
})
export const useSparepartSubPost = (type: SparepartSubType, body: RemoveUnusedDbFields<sparepart_jenis>) => useFetch(`/api/sparepart/sub/${type}`, {
  method: 'POST',
  body
})
export const useSparepartSubDelete = (type: SparepartSubType, id: number) => useFetch(`/api/sparepart/sub/${type}/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useBiayaAlatBeratSparepart
export const useBiayaAlatBeratSparepartGet = (data?: { query?: BiayaAlatBeratSparepartGetQuery }) => {
  return useFetch('/api/biaya-alat-berat-sparepart', JSON.parse(JSON.stringify(data || {})))
}
export const useBiayaAlatBeratSparepartGetId = (id: number) => useFetch(`/api/biaya-alat-berat-sparepart/${id}`)
export const useBiayaAlatBeratSparepartPut = (id: number, body: RemoveUnusedDbFields<ConvertToJsonType<biaya_alat_berat_sparepart>>) => useFetch(`/api/biaya-alat-berat-sparepart/${id}`, {
  method: 'PUT',
  body
})
export const useBiayaAlatBeratSparepartPost = (body: RemoveUnusedDbFields<ConvertToJsonType<biaya_alat_berat_sparepart>>) => useFetch('/api/biaya-alat-berat-sparepart', {
  method: 'POST',
  body
})
export const useBiayaAlatBeratSparepartDelete = (id: number) => useFetch(`/api/biaya-alat-berat-sparepart/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useBiayaAlatBeratRandom
export const useBiayaAlatBeratRandomGet = (data?: { query?: BiayaAlatBeratRandomGetQuery }) => {
  return useFetch('/api/biaya-alat-berat-random', JSON.parse(JSON.stringify(data || {})))
}
export const useBiayaAlatBeratRandomGetId = (id: number) => useFetch(`/api/biaya-alat-berat-random/${id}`)
export const useBiayaAlatBeratRandomPut = (id: number, body: RemoveUnusedDbFields<ConvertToJsonType<biaya_alat_berat_random>>) => useFetch(`/api/biaya-alat-berat-random/${id}`, {
  method: 'PUT',
  body
})
export const useBiayaAlatBeratRandomPost = (body: RemoveUnusedDbFields<ConvertToJsonType<biaya_alat_berat_random>>) => useFetch('/api/biaya-alat-berat-random', {
  method: 'POST',
  body
})
export const useBiayaAlatBeratRandomDelete = (id: number) => useFetch(`/api/biaya-alat-berat-random/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useBiayaAlatBeratSparepartBebas
export const useBiayaAlatBeratSparepartBebasGet = (data?: { query?: BiayaAlatBeratSparepartBebasGetQuery }) => {
  return useFetch('/api/biaya-alat-berat-sparepart-bebas', JSON.parse(JSON.stringify(data || {})))
}
export const useBiayaAlatBeratSparepartBebasGetId = (id: number) => useFetch(`/api/biaya-alat-berat-sparepart-bebas/${id}`)
export const useBiayaAlatBeratSparepartBebasPut = (id: number, body: RemoveUnusedDbFields<ConvertToJsonType<biaya_alat_berat_sparepart_bebas>>) => useFetch(`/api/biaya-alat-berat-sparepart-bebas/${id}`, {
  method: 'PUT',
  body
})
export const useBiayaAlatBeratSparepartBebasPost = (body: RemoveUnusedDbFields<ConvertToJsonType<biaya_alat_berat_sparepart_bebas>>) => useFetch('/api/biaya-alat-berat-sparepart-bebas', {
  method: 'POST',
  body
})
export const useBiayaAlatBeratSparepartBebasMultiPost = (body: RemoveUnusedDbFields<ConvertToJsonType<BiayaSparepartBebasMulti>>) => useFetch('/api/biaya-alat-berat-sparepart-bebas-multi', {
  method: 'POST',
  body
})
export const useBiayaAlatBeratSparepartBebasDelete = (id: number) => useFetch(`/api/biaya-alat-berat-sparepart-bebas/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useBiayaAlatBeratBebasVendor
export const useBiayaAlatBeratSparepartBebasVendorGet = () => useFetch('/api/biaya-alat-berat-sparepart-bebas-vendor')
// #endregion

// #region useImageAlatBerat
export const useImageAlatBeratGet = (data: { query: ImageAlatBeratQuery }) => {
  return useFetch('/api/image-alat-berat', JSON.parse(JSON.stringify(data || {})))
}
export const useImageAlatBeratDelete = (id: number) => useFetch(`/api/image-alat-berat/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useRentAlatBerat
export const useRentAlatBeratGet = (data?: { query?: RentAlatBeratGetQuery }) => useFetch('/api/rent-alat-berat', JSON.parse(JSON.stringify(data || {})))
export const useRentAlatBeratGetId = (id: number, transactionsId: number) => useFetch(`/api/rent-alat-berat/${id}/${transactionsId}`)
export const useRentAlatBeratPut = (id: number, transactionsId: number, body: RemoveUnusedDbFields<ConvertToJsonType<rent_alat_berat>> & RemoveUnusedDbFields<ConvertToJsonType<rent_alat_berat_transactions>>) => useFetch(`/api/rent-alat-berat/${id}/${transactionsId}`, {
  method: 'PUT',
  body
})
export const useRentAlatBeratPost = (body: RemoveUnusedDbFields<ConvertToJsonType<rent_alat_berat>> & RemoveUnusedDbFields<ConvertToJsonType<rent_alat_berat_transactions>>) => useFetch('/api/rent-alat-berat/', {
  method: 'POST',
  body
})
export const useRentAlatBeratDelete = (id: number) => useFetch(`/api/rent-alat-berat/${id}`, {
  method: 'DELETE'
})
export const useExtendRentAlatBeratPut = (id: number, transactionsId: number, body: RemoveUnusedDbFields<ConvertToJsonType<rent_alat_berat>> & RemoveUnusedDbFields<ConvertToJsonType<rent_alat_berat_transactions>>) => useFetch(`/api/rent-alat-berat/${id}/${transactionsId}/extend-rent`, {
  method: 'POST',
  body
})

// Use PROGRESS_STEP for calculation
export const useProgressRentAlatBeratGetId = (id: number, transactionsId: number, data?: { query?: RentAlatBeratGetQuery }) => useFetch(`/api/rent-alat-berat/${id}/${transactionsId}/progress`, JSON.parse(JSON.stringify(data || {})))
export const useProgressRentAlatBeratPost = (id: number, transactionsId: number, body: RemoveUnusedDbFields<ConvertToJsonType<rent_alat_berat_transactions_progress>>) => useFetch(`/api/rent-alat-berat/${id}/${transactionsId}/progress`, {
  method: 'POST',
  body
})
export const useProgressRentAlatBeratPut = (id: number, transactionsId: number, progressId: number, body: RemoveUnusedDbFields<ConvertToJsonType<rent_alat_berat_transactions_progress>>) => useFetch(`/api/rent-alat-berat/${id}/${transactionsId}/progress/${progressId}`, {
  method: 'PUT',
  body
})
export const useProgressRentAlatBeratDelete = (id: number, transactionsId: number, progressId: number) => useFetch(`/api/rent-alat-berat/${id}/${transactionsId}/progress/${progressId}`, {
  method: 'DELETE',
})
// #endregion

// #region useSellAlatBerat
export const useSellAlatBeratGet = () => useFetch('/api/sell-alat-berat')
export const useSellAlatBeratGetId = (id: number) => useFetch(`/api/sell-alat-berat/${id}`)
export const useSellAlatBeratPut = (id: number, body: RemoveUnusedDbFields<ConvertToJsonType<sell_alat_berat>>) => useFetch(`/api/sell-alat-berat/${id}`, {
  method: 'PUT',
  body
})
export const useSellAlatBeratPost = (body: RemoveUnusedDbFields<ConvertToJsonType<sell_alat_berat>>) => useFetch('/api/sell-alat-berat/', {
  method: 'POST',
  body
})
export const useSellAlatBeratDelete = (id: number) => useFetch(`/api/sell-alat-berat/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useBuyAlatBerat
export const useBuyAlatBeratPut = (id: number, body: detailed_alat_berat_buy) => useFetch(`/api/buy-alat-berat/${id}`, {
  method: 'PUT',
  body
})
export const useBuyAlatBeratPost = (body: detailed_alat_berat_buy) => useFetch('/api/buy-alat-berat/', {
  method: 'POST',
  body
})
// #endregion

// #region useBuySparepart
export const useBuySparepartGet = (data?: {
  query?: BuySparepartGetQuery
}) => useFetch('/api/buy-sparepart', JSON.parse(JSON.stringify(data || {})))
export const useBuySparepartGetId = (id: number) => useFetch(`/api/buy-sparepart/${id}`)
export const useBuySparepartPut = (id: number, body: RemoveUnusedDbFields<ConvertToJsonType<buy_sparepart>>) => useFetch(`/api/buy-sparepart/${id}`, {
  method: 'PUT',
  body
})
export const useBuySparepartPost = (body: RemoveUnusedDbFields<ConvertToJsonType<buy_sparepart>>) => useFetch('/api/buy-sparepart/', {
  method: 'POST',
  body
})
export const useBuySparepartMultiPost = (body: BuySparepartMulti) => useFetch('/api/buy-sparepart-multi', {
  method: 'POST',
  body
})
export const useBuySparepartDelete = (id: number) => useFetch(`/api/buy-sparepart/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useLogHistory
export const useLogHistoryGet = (data: {
  query?: LogHistoryQuery
}) => useFetch('/api/log-history', JSON.parse(JSON.stringify(data || {})))
// #endregion

// #region useLogin
export const useLoginPost = (body: RemoveUnusedDbFields<ConvertToJsonType<login>>) => useFetch('/api/login/', {
  method: 'POST',
  body
})
export const useLoginValidateGet = () => useFetch('/api/login/validate')
// #endregion

// #region useCopotan
export const useCopotanGet = () => useFetch('/api/copotan')
export const useCopotanGetId = (id: number) => useFetch(`/api/copotan/${id}`)
export const useCopotanPut = (id: number, body: RemoveUnusedDbFields<ConvertToJsonType<copotan>>) => useFetch(`/api/copotan/${id}`, {
  method: 'PUT',
  body
})
export const useCopotanPost = (body: RemoveUnusedDbFields<ConvertToJsonType<detailed_copotan_image>>) => useFetch('/api/copotan', {
  method: 'POST',
  body
})
export const useCopotanDelete = (id: number) => useFetch(`/api/copotan/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region useImageCopotan
export const useImageCopotanGet = (data: { query: ImageCopotanQuery }) => {
  return useFetch('/api/image-copotan', JSON.parse(JSON.stringify(data || {})))
}
export const useImageCopotanDelete = (id: number) => useFetch(`/api/image-copotan/${id}`, {
  method: 'DELETE'
})
// #endregion

// #region usePengirimanSparepart
export const usePengirimanSparepartGet = (data?: { query?: PengirimanSparepartGetQuery }) => {
  return useFetch('/api/pengiriman-sparepart', JSON.parse(JSON.stringify(data || {})))
}
export const usePengirimanSparepartGetId = (id: number) => useFetch(`/api/pengiriman-sparepart/${id}`)
export const usePengirimanSparepartPost = (body: RemoveUnusedDbFields<ConvertToJsonType<pengiriman_sparepart>>) => useFetch('/api/pengiriman-sparepart', {
  method: 'POST',
  body
})
// #endregion
